module.exports = __webpack_public_path__ + "field1.jpg?d71c9b8ef10e47659832d2eac2e6734f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/field1.jpg
// module id = 93
// module chunks = 0